import { useVideoPlayback } from "@/contexts/playback-context";
import { useSelector } from "@legendapp/state/react";

export function MetaInfo() {
  const videoPlayback = useVideoPlayback();
  const camera = useSelector(() => videoPlayback.videoContext.camera.get());
  return (
    <div className="absolute top-0 left-0 z-100 text-white px-10 py-1 flex items-center gap-4">
      <div className="mr-10">Camera: {camera}</div>

      <div className="flex items-center gap-2">
        <span className="block h-1 w-4 bg-blue-500"></span>
        <span className="text-sm">Matched detection</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="block h-1 w-4 border-2 border-dashed border-blue-500"></span>
        <span className="text-sm">2D Reprojection</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="block h-1 w-4 bg-red-500"></span>
        <span className="text-sm">Unmatched detection</span>
      </div>
    </div>
  );
}
